<template>
    <y-rogue-wrapper
        name="profileChargeWallet"
        type="simple"
        :title="$t('dashboard.wallet.charge.title')"
        :description="$t('dashboard.wallet.charge.description')"
        :input="$t('dashboard.wallet.charge.input')"
        :credit-title="$t('dashboard.wallet.charge.credit')"
        :select-gates-title="$t('dashboard.wallet.charge.select_gates')"
        :button="$t('dashboard.wallet.charge.button')"
        :wallets="wallets"
        raised
    />
</template>

<script>
    export default {
        name: 'DashboardChargeWallet',

        props: {
            wallets: Array,
        },

        /**
         * @inheritDoc
         */
        metaInfo() {
            return {
                title: this.$t('dashboard.wallet.charge.title'),
            };
        },
    };
</script>
